import { BindAll } from 'lodash-decorators';
import React from 'react';
import { withRouter } from 'react-router-dom';
import styles from './style.module.less';

@withRouter
@BindAll()
export class ClauseManager extends React.Component {
  render() {
    return (
        <div className={styles.manager}>
            <div className={styles.title}>管理员职责说明 </div>
            <div className={styles.theContent}>
                <div className={styles.titleCont}>a) </div>
                <div className={styles.pCont}>
                    <p> <strong>子账号创建与管理：</strong>管理员账号持有人（以下简称“管理员”）有权在本平台为其团队成员创建并管理子账号。管理员应确保子账号的创建、使用均符合本平台的规则与要求，并对子账号的所有行为承担相应责任。 </p>
                </div>
                <div className={styles.titleCont}>b) </div>
                <div className={styles.pCont}>
                    <p><strong>子账号行为监督：</strong>管理员应定期监督并管理其名下所有子账号的使用情况，确保子账号的使用不违反法律法规、不侵犯他人权益，也不违反本平台的任何规定。管理员应对子账号在本平台上的任何不当行为负责，并应积极配合本平台对子账号行为的调查与处理。</p>
                </div>
                <div className={styles.titleCont}>c) </div>
                <div className={styles.pCont}>
                    <p><strong>子账号信息安全：</strong>管理员应妥善保管子账号的登录凭证，防止子账号被未经授权的人员使用。若因管理员管理不善导致子账号信息泄露或被滥用，管理员应承担相应责任，并赔偿由此给本平台或第三方造成的损失。</p>
                </div>
                <div className={styles.titleCont}>d) </div>
                <div className={styles.pCont}>
                    <p><strong>子账号违规处理：</strong>若子账号违反本平台的任何规定，本平台有权视情节轻重对子账号采取相应的处理措施，包括但不限于限制登录、冻结账号、注销账号等。同时，本平台有权要求管理员协助调查并处理相关事宜。若管理员未能积极配合，本平台有权对管理员账号采取相应措施。</p>
                </div>
            </div>
        </div>
    )
  }
}
